import { Route } from 'react-router-dom';
import { listeNoireViewSchema } from './listeNoire';
import Main from '@app/main/tables/Main';

/**
 * Routes configurées pour le module ListeNoire
 */
const ListeNoireRoutes = [
    // Route de liste (principale)
    <Route
        key="liste-noire"
        path="listeNoire"
        element={
            <Main key="liste-noire-main" pageConfig={listeNoireViewSchema} />
        }
    />,
];

export default ListeNoireRoutes;
